import React from 'react';
import PageTitle from '../../FormElements/PageTitle';
import SubscriptionInfoCard from '../../Marketing/SubscriptionInfoCard';
import PrimaryButton from '../../Buttons/PrimaryButton';

export default class CartIndex extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		// console.log("CartIndex", this.props)
		return (
			<div className="CartIndexPartial pb-4">
				<div className="grid grid-cols-1">
					<div>
						<PageTitle title="Your lodging taxes are about to get a whole lot easier..." />
						<div className="w-full">
							<SubscriptionInfoCard />
							<div className="grid">
								<div className="lg:justify-self-end">
									<PrimaryButton
										label="Continue"
										onClick={this.props.continueLocation}
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
